import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import LanguageSwitcher from "../../language-switcher/LanguageSwitcher";
import { useTranslation } from "../../../hooks/useTranslation";

export default function Header() {
  const [isInAdminPage, setIsInAdminPage] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    location.pathname.includes("admin")
      ? setIsInAdminPage(true)
      : setIsInAdminPage(false);
  }, [location]);

  return (
    <section className="header">
      <NavLink to="/">
        {/*<img*/}
        {/*  className="header-logo"*/}
        {/*  src={"/assets/images/header-logo.svg"}*/}
        {/*  alt="header-logo"*/}
        {/*/>*/}

        <div className="logo">
          {isInAdminPage ? t("header.adminLogo") : t("header.logo")}
        </div>
      </NavLink>

      <div className="header-actions">
        <LanguageSwitcher />
        {/* {isInAdminPage ? null : (
        <a
        className="study-form-link-btn"
            href="https://forms.gle/qHAcn9VPgv4nbUUJ8"
            target="_blank"
           rel="noreferrer"
          >
            <div>{t("header.studyForm")}</div>
            <img
              src={"/assets/icons/ArrowRightWhite.svg"}
            />
          </a>
        )} */}
      </div>
    </section>
  );
}
